import type { IPackChatThreadSummary, IPackChatThreadsResponse } from "./types";

/** Update a summary and counts without replacing the server's list order. */
export const updateThreadSummary = (
  current: IPackChatThreadsResponse | undefined,
  thread: IPackChatThreadSummary,
): IPackChatThreadsResponse | undefined => {
  if (!current) return current;

  const threads = current.threads.map((candidate) =>
    candidate.id === thread.id ? { ...candidate, ...thread } : candidate,
  );

  return {
    ...current,
    threads,
    ...(current.needs_manager_count !== undefined
      ? {
          needs_manager_count: threads.filter(
            (candidate) => candidate.needs_manager,
          ).length,
        }
      : {}),
    open_count: threads.filter((candidate) => candidate.status === "open")
      .length,
  };
};
